import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import lumnisLogo from "../../assets/images/logo/lumnis.png";
import { BsLinkedin, BsInstagram, BsMedium } from "react-icons/bs";
import { TeamCard } from "Components/TeamCard";
import abubakarr_jaye from "assets/images/team/abubakarr_jaye.png";
import pavan_otthi from "assets/images/team/pavan_otthi.png";
import pedro_gonzález_de_velasco from "assets/images/team/pedro_gonzález_de_velasco.png";
import ivar_yuste from "assets/images/team/ivar_yuste.png";
import priya_goel from "assets/images/team/priya_goel.png";
import pedro_gonzález_de_velasco_1 from "assets/images/team/pedro_gonzález_de_velasco_1.png";

export const About = () => {
  const teamArray = [
    {
      name: "Abubakarr Jaye",
      designation: "CEO",
      qualification: "B.S. in Computer Science and Economics",
      linkedinUrl: "https://linkedin.com",
      img: abubakarr_jaye,
      // img: "assets/images/team/abubakarr_jaye.png",
    },
    {
      name: "Pavan Otthi",
      designation: "CTO",
      qualification: "B.S. in Computer Engineering",
      linkedinUrl: "https://linkedin.com",
      img: pavan_otthi,
      // img: "assets/images/team/pavan_otthi.png",
    },
    {
      name: "Pedro González de Velasco",
      designation: "COO",
      qualification: "B.A. in History and Economics",
      linkedinUrl: "https://linkedin.com",
      img: pedro_gonzález_de_velasco,
      // img: "assets/images/team/pedro_gonzález_de_velasco.png",
    },
    {
      name: "Ivar Yuste",
      designation: "Chief Research Analyst",
      qualification: "B.S in Management with Finance and Law",
      linkedinUrl: "https://linkedin.com",
      img: ivar_yuste,
      // img: "assets/images/team/ivar_yuste.png",
    },
    {
      name: "Priya Goel",
      designation: "Lead UI/UX Designer",
      qualification: "B.S. in Graphic Design, B.F.A in Psychology",
      linkedinUrl: "https://linkedin.com",
      img: priya_goel,
      // img: "assets/images/team/priya_goel.png",
    },
    {
      name: "Pedro González de Velasco",
      designation: "Lead UI/UX Designer",
      qualification: "B.F.A. in Design and Technology",
      linkedinUrl: "https://linkedin.com",
      img: pedro_gonzález_de_velasco_1,
      // img: "assets/images/team/Pedro_gonzález_de_velasco_1.png",
    },
  ];
  return (
    <div>
      <section className="py-5" style={{ background: "#FAFDFF" }}>
        <Container>
          <Row className="align-items-center my-md-5">
            <Col lg="6" className="mb-4">
              <div>
                <img
                  src={lumnisLogo}
                  alt="Logo"
                  width="100%"
                  height="auto"
                  className="img-fluid obj-fit-cover obj-position-center"
                />
              </div>
            </Col>
            <Col lg="6" className="mb-4">
              <div>
                <h2 className="text-dark">Our Vision</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam
                  faucibus tincidunt elementum. Proin neque enim, convallis
                  varius ligula quis, accumsan ultrices magna. Pellentesque
                  facilisis eu ex et gravida.
                </p>
                <div
                  className="d-flex align-items-center justify-content-start"
                  style={{ gap: "2rem" }}
                >
                  <a href="/" className="h3 text-linkedin" target={"_blank"}>
                    <BsLinkedin />
                  </a>
                  <a href="/" className="h3 text-dark" target={"_blank"}>
                    <BsInstagram />
                  </a>
                  <a href="/" className="h3 text-dark" target={"_blank"}>
                    <BsMedium />
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="my-5">
        <Container>
          <Row className="justify-content-center">
            <Col xl="10">
              <Row>
                <Col xs="12">
                  <h2 className="text-center text-capitalize text-black mb-4">
                    Meet The Team
                  </h2>
                </Col>
                {teamArray.map((team, index) => {
                  return (
                    <Col xs="12" sm="6" lg="4" key={index} className="mb-4">
                      <TeamCard {...team} />
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};
